import React, {useEffect, useRef} from 'react'

// @ts-ignore
import html2pdf from 'html2pdf.js'

interface PrintingComponentProps {
    componentToPrint: JSX.Element;
    textButon: string
    orientation?: string
    childToParent?: any
}
export default function PrintingComponent({ componentToPrint ,textButon, orientation = 'portrait', childToParent}: PrintingComponentProps) {
    const folhaRef = useRef<HTMLDivElement>(null);
    let element = document.getElementById('folha')

    async function  handleGeneratePDF() {
        await new Promise<void>((resolve) => {
            const intervalId = setInterval(() => {
                if (folhaRef.current?.offsetHeight) {
                    clearInterval(intervalId);
                    resolve();
                }
            }, 100);
        }).then(()=>{
            const folha = folhaRef.current;

            if (!folha){
                return;
            } else {
                element = document.getElementById('folha')
            }

            var pageWidth = 1200

            if (orientation == 'landscape'){
                pageWidth = 1800
            }

            if (element){
                element.style.width = `${pageWidth}px`;
            }

            var opt = {
                filename: 'planilha.pdf',
                margin: 10,
                html2canvas:  { dpi: 192, scale: 2, letterRendering: true, width: pageWidth, windowWidth: pageWidth},
                jsPDF: {format: 'a4', orientation: orientation},
                pageBreak: { mode: 'avoid-all'}
            }

            html2pdf().set(opt).from(element).toPdf().get('pdf').then(function (pdfObj: any) {
                window.open(pdfObj.output('bloburl'), '_blank')
            })
        })
    }

    async function printPDF() {
        await handleGeneratePDF()
    }

    useEffect(() => {
        const fetchData = async () => {
            if (textButon === '') {
                await printPDF().then(() => {
                    if (childToParent) {
                        childToParent('imprimiu');
                    }
                })
            }
        };

        fetchData()
    },  [])

    return (
        <>
            {textButon !== "" &&
                <span onClick={printPDF}> &nbsp; {textButon}</span>
            }

            <div ref={folhaRef}>
                <div style={{visibility: 'collapse'}}>
                    <div id='folha' className='folha'>
                        {componentToPrint}
                    </div>
                </div>
            </div>
        </>
    )
}
